import { render, staticRenderFns } from "./BargeList.vue?vue&type=template&id=5fd13cb3&scoped=true"
import script from "./BargeList.vue?vue&type=script&lang=js"
export * from "./BargeList.vue?vue&type=script&lang=js"
import style0 from "./BargeList.vue?vue&type=style&index=0&id=5fd13cb3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd13cb3",
  null
  
)

export default component.exports